<template>
    <div name="soldoc-partners-review" class="soldoc-partners-review" id="soldoc-partners-review">
        <div class="soldoc-partners-review-inner">
            <h3>솔닥파트너스 도입하고<br> 이렇게 달라졌어요</h3>
            <ul class="review-list">
                <li>
                    <strong>솔닥을 통해 찾아오는 신환이<br>많이 늘었어요</strong>
                    <p>병원이 눈에 띄지 않는 곳에 위치해서 홍보에 어려움이 있었는데 솔닥 앱을 통해 병원을 찾아오는 신환이 많이 늘었어요. 앱 내에서 병원이 노출되면 자연스럽게 병원 홍보가 되더라고요.</p>
                    <span>서울시 강남구 D 피부과</span>
                </li>
                <li>
                    <strong>MD 판매도 수월해지고<br>매출 상승은 덤으로 얻었어요</strong>
                    <p>보습제와 같은 MD 판매 시 솔닥에서 물류와 배송을 책임지는 시스템이니 재고 부담 없이 다양한 MD를 판매할 수 있어요.<br>그에 따라 자연스럽게 매출도 늘어서 병원에 활력이 도네요.</p>
                    <span>부산시 동래구 O 가정의학과</span>
                </li>
                <li>
                    <strong>차트 병행 사용이 걱정됐는데<br>오히려 훨씬 편리했어요</strong>
                    <p>사용 중인 차트와 솔닥파트너스를 함께 사용<br>하는 점이 걱정되었지만, 오히려 솔닥 고객들은 솔닥 파트너스로 한번에 관리할 수 있기<br> 때문에 저나 데스크 선생님들 모두 쉽고<br>편하게 사용하고 있습니다.</p>
                    <span>대구시 남구 S 내과</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "soldoc-partners-review",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".soldoc-partners-review-inner").offset().top;
            var aniTitle = $(".soldoc-partners-review-inner > h3");
            var aniItem = $(".soldoc-partners-review-inner .review-list");

            if (height <= 0) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1600) {
                $(aniTitle).removeClass('item-hide').addClass('item-show');
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 2000) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.soldoc-partners-review {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 1677px;
    background: #FFF;
    overflow: hidden;
}
.soldoc-partners-review-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding: 100px 34px;
}
.soldoc-partners-review-inner h3 {
    min-height: 84px;
    margin-bottom: 0;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    color: #000;
    text-align: center;
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-review-inner .review-list {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 30px;
    list-style: none;
    width: 346px;
    padding: 0;
    margin: 0;
    margin-top: 67px;
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-review-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-review-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.soldoc-partners-review .review-list li {
    position: relative;
    height: 422px;
    padding: 40px 30px;
    border-radius: 20px;
    border: 1px solid #CCC;
    background: #FFF;
    overflow: hidden;
}
.soldoc-partners-review .review-list li strong {
    font-size: 20px;
    font-weight: 600;
    color: #000;
    line-height: 30px;
}
.soldoc-partners-review .review-list li p {
    margin: 16px 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #666;
}
.soldoc-partners-review .review-list li span {
    font-size: 14px;
    font-weight: 400;
    line-height: 30px;
    color: #008DEF;
}
.soldoc-partners-review .review-list li::before {
    content: '';
    position: absolute;
    bottom: 0;
}
.soldoc-partners-review .review-list li:first-child::before {
    right: 0;
    width: 249px;
    height: 194px;
    background: url(../../assets/partners_mobile/img_soldoc_partners_review1.png) 0 0 no-repeat;
    background-size: 249px auto;
}
.soldoc-partners-review .review-list li:nth-child(2)::before {
    right: 23px;
    width: 178px;
    height: 183px;
    background: url(../../assets/partners_mobile/img_soldoc_partners_review2.png) 0 0 no-repeat;
    background-size: 178px auto;
}
.soldoc-partners-review .review-list li:last-child::before {
    right: 12px;
    width: 161px;
    height: 183px;
    background: url(../../assets/partners_mobile/img_soldoc_partners_review3.png) 0 0 no-repeat;
    background-size: 161px auto;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 50%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}

@media screen and (max-width: 359px) {
    .soldoc-partners-review {
        height: auto;
    }
    .soldoc-partners-review-inner {
        padding: 100px 20px;
    }
    .soldoc-partners-review .review-list {
        width: 100%;
    }
    .soldoc-partners-review .review-list li strong {
        font-size: 18px;
        line-height: 28px;
    }
    .soldoc-partners-review .review-list li p {
        font-size: 14px;
        line-height: 24px;
    }
    .soldoc-partners-review .review-list li span {
        font-size: 13px;
        line-height: 29px;
    }
    .soldoc-partners-review .review-list li:first-child::before {
        right: -9px;
        width: 224.1px;
        height: 174.6px;
        background-size: 224.1px auto;
    }
    .soldoc-partners-review .review-list li:nth-child(2)::before {
        right: 10px;
        width: 160.2px;
        height: 164.7px;
        background-size: 160.2px auto;
    }
    .soldoc-partners-review .review-list li:last-child::before {
        right: 5px;
        width: 144.9px;
        height: 164.7px;
        background-size: 144.9px auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/SoldocPartnersReview.vue